import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.SET_SELECTED_CLASS_EVALUATION_DOMAINS](state, { classId, selectedDomainIds }) {
    Vue.set(state.selectedClassEvaluationDomainIds, classId, selectedDomainIds);
  },

  [types.SET_CLASS_EVALUATION_DOMAINS](state, { classId, domains }) {
    Vue.set(state.classEvaluationDomains, classId, domains);
  },

  [types.SET_EVALUATION_LIST](state, evaluationList) {
    Vue.set(state, 'evaluationList', evaluationList.map((evaluation, index) => ({
      ...evaluation,
      index,
    })));
  },

  [types.SET_EVALUATION](state, { index, evaluation }) {
    Vue.set(state.evaluationList, index, { ...evaluation, index });
  },

  [types.SET_EVALUATION_FILTER](state, { property, value }) {
    Vue.set(state.evaluationFilters, property, value);
  },

  [types.SET_EVALUATION_CRITERIA](state, evaluationCriteria) {
    Vue.set(state, 'evaluationCriteria', evaluationCriteria);
  },

  [types.SET_EVALUATION_ORDER_BY](state, evaluationOrderBy) {
    Vue.set(state, 'evaluationOrderBy', evaluationOrderBy);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/evaluations/store/mutations.js